var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrystalleagueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0069AB",
    d: "M61.15 10.166H76.8v7.867c0 3.573-1.467 6.786-4.459 9.889-2.382 2.465-5.706 4.792-9.916 6.952l-1.302-.581V10.166m-6.233-6.15V38.31l7.645 3.38C73.338 36.73 82.978 29.25 82.978 18.06V5.79c0-.97-.803-1.773-1.8-1.773H54.861h.028ZM34.946 10.166v24.127l-1.302.581c-4.21-2.16-7.534-4.487-9.916-6.952-2.992-3.103-4.46-6.316-4.46-9.89v-7.866h15.65m6.233-6.15H14.864c-.998 0-1.8.804-1.8 1.773V18.06c0 11.191 9.666 18.67 20.442 23.628l7.645-3.379V4.017Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0069AB",
    fillRule: "evenodd",
    d: "M46.94 42.63c-18.198 0-32.048-15.124-32.048-33.766 0-1.967 1.412-2.992 1.717-4.875H6.693l3.905 4.653-3.629 5.291 4.626 3.629-2.327 6.01 5.346 2.383-.858 6.399 5.761.997.665 6.426L26 39.334l2.16 6.066 5.54-1.856 4.294-.36 4.155 2.576 4.654 4.35 4.072-4.267-3.989-3.213h.055Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0069AB",
    fillRule: "evenodd",
    d: "m45.168 45.843 4.072 4.266 4.653-4.349 4.155-2.576 4.294.36 5.54 1.856 2.16-6.066 5.817.443.665-6.426 5.762-.997-.86-6.4 5.347-2.381-2.327-6.011 4.626-3.629-3.656-5.263 3.905-4.653h-9.916c.305 1.883 1.717 2.908 1.717 4.875 0 18.642-13.85 33.766-32.049 33.766l-3.989 3.213.084-.028Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0069AB",
    d: "M63.034 41.688c-9.944-5.096-19.916-5.096-29.86 0 5.983 3.878 7.922 7.756 5.816 11.634-1.024 1.856 19.086 1.69 18.116-.249-1.911-3.795.083-7.59 5.956-11.385h-.028Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BA6DE",
    d: "M54.613 46.01h-13.13c-7.45 0-13.628-5.679-14.182-13.02l-2.3-30.746A2.088 2.088 0 0 1 27.108 0h41.91a2.104 2.104 0 0 1 2.105 2.244l-2.299 30.719c-.554 7.34-6.73 13.019-14.182 13.019l-.028.028Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87CBE3",
    d: "M67.272 11.219c-3.767-.444-6.73-3.38-7.174-7.12 0-.083-.11-.083-.11 0-.444 3.712-3.436 6.676-7.175 7.12-.083 0-.083.11 0 .11 3.767.444 6.73 3.38 7.174 7.12 0 .082.11.082.11 0 .444-3.713 3.436-6.677 7.175-7.12.083 0 .083-.11 0-.11ZM48.048 18.06V5.79c0-.804-.526-1.469-1.246-1.69H29.794c-.25 0-.47.221-.443.47l2.105 28.088c.11 1.44.526 2.77 1.164 3.961.304.554.969.804 1.55.61 8.061-2.715 13.878-10.277 13.878-19.169Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BA6DE",
    d: "M68.13 50.47H27.967a3.103 3.103 0 0 0-3.13 3.102v4.515c0 1.08.886 1.967 1.994 1.967h42.464c1.108 0 1.995-.887 1.995-1.967v-4.515c0-1.718-1.413-3.103-3.13-3.103h-.028Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v60H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystalleagueIcon);
export default __webpack_public_path__ + "static/media/crystalleagueIcon.77267508883f660b3453ba3a89dc6c4c.svg";
export { ForwardRef as ReactComponent };